import type {
    MountGuideHome,
    MountGuideMountDetail,
    MountGuideRegionDetail,
} from '../types';

/** Tempo que os dados ficam “frescos” sem nova requisição (só RAM do navegador). */
const TTL_MS = 10 * 60 * 1000;

type Entry<T> = { data: T; fetchedAt: number };

let homeEntry: Entry<MountGuideHome> | null = null;
const regionEntries = new Map<string, Entry<MountGuideRegionDetail>>();
const mountEntries = new Map<string, Entry<MountGuideMountDetail>>();

function isFresh<T>(entry: Entry<T> | null | undefined): entry is Entry<T> {
    if (!entry) return false;
    return Date.now() - entry.fetchedAt < TTL_MS;
}

export function getCachedMountGuideHome(): MountGuideHome | null {
    return homeEntry?.data ?? null;
}

export function getCachedMountGuideRegion(slug: string): MountGuideRegionDetail | null {
    return regionEntries.get(slug)?.data ?? null;
}

export function getCachedMountGuideMount(slug: string): MountGuideMountDetail | null {
    return mountEntries.get(slug)?.data ?? null;
}

export function isMountGuideHomeFresh(): boolean {
    return isFresh(homeEntry);
}

export function isMountGuideRegionFresh(slug: string): boolean {
    return isFresh(regionEntries.get(slug));
}

export function isMountGuideMountFresh(slug: string): boolean {
    return isFresh(mountEntries.get(slug));
}

export function setCachedMountGuideHome(data: MountGuideHome): void {
    homeEntry = { data, fetchedAt: Date.now() };
}

export function setCachedMountGuideRegion(slug: string, data: MountGuideRegionDetail): void {
    regionEntries.set(slug, { data, fetchedAt: Date.now() });
}

export function setCachedMountGuideMount(slug: string, data: MountGuideMountDetail): void {
    mountEntries.set(slug, { data, fetchedAt: Date.now() });
}

/** Limpa cache público após alterações no admin (dados podem ter mudado). */
export function invalidateMountGuideCache(): void {
    homeEntry = null;
    regionEntries.clear();
    mountEntries.clear();
}
